import { TIER_AUDIO_META, PORTFOLIO_TIER_META } from '../lib/oraculoAudio';

/**
 * HeroAudioPlayer — Reproductor prominente al top de las pantallas de analisis
 * (acciones, portafolios). Diseno: gradient navy + play button grande +
 * subtitulo descriptivo. Audio HTML5 nativo con filter invert para legibilidad
 * sobre fondo oscuro.
 *
 * Props:
 *   src      URL completa del .mp3 (null oculta el componente)
 *   tier     'basic' | 'intermediate' | 'advanced' | 'premium'
 *   label    (opcional) override del label superior. Default: "Escuchar · {labelHint}"
 *   labelHint  (opcional) texto despues de "Escuchar ·". Default: ""
 *   kind     'stock' | 'portfolio' — determina qué metadata usar
 *            (default: 'stock')
 */
export default function HeroAudioPlayer({ src, tier, label, labelHint = '', kind = 'stock' }) {
  if (!src) return null;
  const metaTable = kind === 'portfolio' ? PORTFOLIO_TIER_META : TIER_AUDIO_META;
  const meta = metaTable[tier] || metaTable.basic;
  const topLabel = label || `Escuchar${labelHint ? ` · ${labelHint}` : ''}`;
  return (
    <div className="bg-gradient-to-br from-[#0a2540] to-[#1a3a6c] rounded-xl p-4 mb-3 text-white">
      <div className="text-[10px] uppercase tracking-wider opacity-70 mb-1">{topLabel}</div>
      <div className="text-sm font-semibold mb-1 leading-snug">{meta.label}</div>
      <p className="text-xs opacity-80 mb-3 leading-relaxed">{meta.subtitle}</p>
      {/* key={src} fuerza re-render del audio al cambiar tier */}
      <audio
        key={src}
        controls
        controlsList="nodownload"
        src={src}
        className="w-full h-8"
        preload="metadata"
        style={{ filter: 'invert(1) hue-rotate(180deg)' }}
      />
    </div>
  );
}
